const features = [
  {
    feature: "New user set-up process and security model",
    id: 1,
  },

  {
    feature: "Customer structure, including service level details",
    id: 2,
  },
  {
    feature: "Enterprise and business unit hierarchy",
    id: 3,
  },
  {
    feature:
      "Visibility and reporting of roll-up information to enterprise or ASC levels",
    id: 4,
  },

  {
    feature: "Search, sort, filter and export all grid screens",
    id: 5,
  },
  {
    feature: "Chemical regulatory lists",
    id: 6,
  },
  {
    feature: "Dashboard functionality",
    id: 7,
  },

  {
    feature: "Updated look and feel (UI) ",
    id: 8,
  },
  {
    feature: "Streamlining current user pain points",
    id: 9,
  },
];

export default features;
